import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props
import { IPaginationResourceShort } from '../../../../../props/general';

// components
import { ActionButton, CommandBar, IColumn, ICommandBarItemProps, IContextualMenuItem, Persona, PrimaryButton, SearchBox, SelectionMode, ShimmeredDetailsList, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';
import ContactForm from '../form';
import { IPublicContactResourceshort } from '../../../../../props/users/contact';
import ContactService from '../../../../../services/users/contact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';
import GeneralService from '../../../../../services/general';
import GlobalConfig from '../../../../../config';
import CustomPersona from '../../../../uiframeworks/persona';

interface IContactsListProps {
}

const ContactsList: React.FC<IContactsListProps> = (props: IContactsListProps) => {
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [showingMore, setShowingMore] = React.useState<boolean>(false);
    const [contacts, setContacts] = React.useState<IPublicContactResourceshort[]>([]);
    const [activeContact, setActiveContact] = React.useState<IPublicContactResourceshort | undefined>();
    const [pagination, setPagingation] = React.useState<IPaginationResourceShort | undefined>();
    const [keyword, setKeyword] = React.useState<string>("");
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    const columns: IColumn[] = [
        {
            key: 'prifilePicture',
            name: 'Profile Picture',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicContactResourceshort) => {
                return (
                    <Stack>
                        <CustomPersona imageInitials={GeneralService.getInitial(item.name)} imageUrl={item.profile_picture_url} />
                    </Stack>
                );
            },
        },
        {
            key: 'name',
            name: 'Name',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicContactResourceshort) => {
                return <Stack>
                    <Text>{item.name}</Text>
                </Stack>;
            },
        },
        {
            key: "actions",
            name: "",
            minWidth: 50,
            maxWidth: 50,
            onRender: (item: IPublicContactResourceshort) => {
                let menuItems: IContextualMenuItem[] = [
                    {
                        key: "update", text: "Update details", iconProps: { iconName: "Edit" }, onClick: () => {
                            setActiveContact(item);
                            setActiveSurface('update');
                        },
                    },
                    {
                        key: "delete",
                        text: "Delete",
                        iconProps: { iconName: "Delete" },
                        onClick: () => {
                            onDelete(item)
                        },
                    }
                ];

                return <Stack.Item styles={{ root: { padding: '2px 0px' } }}>
                    <Stack.Item className={"detailsListActionRow"}>
                        <ActionButton className={'detailsListActionButton'} menuProps={{
                            items: menuItems
                        }} />
                    </Stack.Item>
                </Stack.Item>;
            }
        },
        {
            key: 'alias',
            name: 'Alias',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicContactResourceshort) => {
                return (
                    <Stack>
                        <Text>{item.alias}</Text>
                    </Stack>
                );
            },
        },
        {
            key: 'phone_number',
            name: 'Phone Number',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicContactResourceshort) => {
                return (
                    <Stack>
                        <Text>{item.phone_number}</Text>
                    </Stack>
                );
            },
        },
        {
            key: 'is_featured',
            name: 'Is Featured',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicContactResourceshort) => {
                return (
                    <Stack verticalAlign='center'>
                        <Stack horizontal>{item.is_featured ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faXmark} />}</Stack>
                    </Stack>
                );
            },
        },
    ];

    const onDelete = async (item: IPublicContactResourceshort) => {
        if (window.confirm(`Hapus ${item.name}?`)) {
            setContacts([...contacts.filter(f => f.id !== item.id)])
            try {
                await ContactService.delete(item.id)
            } catch (error) {
            }
        }
    }

    useEffect(() => {
        _onRetrieveContacts();
    }, []);

    useEffect(() => {
        _onRetrieveContacts();
    }, [keyword]);

    const _onRetrieveContacts = async (pageNumber?: number,) => {
        const qs: string[] = [];
        if (pageNumber) { qs.push(`page=${pageNumber}`); }
        if (keyword && keyword.trim() !== "") { qs.push(`search=${keyword}`) }
        try {
            const items = await ContactService.retrieve(qs.join("&"))
            setContacts(items)

            setPagingation(undefined);
            setLoaded(true);
        } catch (error) {

        }
    }

    const _onKeywordChanged = (value?: string) => {
        setLoaded(true);
        setKeyword(value || "");
    }

    const getCommandBarItems = () => {
        let items: ICommandBarItemProps[] = [];
        let farItems: ICommandBarItemProps[] = [];

        items.push({
            key: "search",
            onRender: () => {
                return <SearchBox placeholder={"Search ..."} onSearch={_onKeywordChanged} />
            }
        });

        farItems.push({
            key: "register",
            text: "Create Contact",
            iconProps: { iconName: "Add" },
            onRender: () => {
                return <PrimaryButton text={"Create Contact"}
                    iconProps={{ iconName: "Add" }}
                    onClick={() => { setActiveSurface('create') }}
                    styles={{ root: { marginLeft: 10 } }} />;
            }
        });

        return { items, farItems };
    }

    const _onSurfaceDismissed = (refresh?: boolean) => {
        setActiveSurface(undefined);
        setActiveContact(undefined);

        if (refresh) { _onRetrieveContacts() }
    }

    return <Stack className={styles.container} tokens={{ childrenGap: 20 }}>
        <CommandBar
            items={getCommandBarItems().items}
            farItems={getCommandBarItems().farItems}
            styles={{
                root: {
                    padding: 0,
                    height: 'unset',
                    backgroundColor: 'transparent'
                }
            }}
            ariaLabel="Use left and right arrow keys to navigate between commands" />
        <Stack className={styles.list}>
            {
                !loaded || (loaded && contacts.length > 0) ? (
                    <>
                        <ShimmeredDetailsList
                            setKey="items"
                            items={contacts}
                            columns={columns}
                            selectionMode={SelectionMode.none}
                            enableShimmer={!loaded}
                            onShouldVirtualize={() => false}
                            ariaLabelForShimmer="Content is being fetched"
                            ariaLabelForGrid="Item details" />
                    </>
                ) : null
            }
            {loaded && contacts.length < 1 ? <Stack styles={{ root: { padding: 10 } }}>
                <Text>Contact(s) not found</Text>
            </Stack> : null}
        </Stack>
        {activeSurface === 'create' ? <ContactForm onDismissed={_onSurfaceDismissed} /> : null}
        {activeSurface === 'update' && activeContact ? <ContactForm contactId={activeContact.id} onDismissed={_onSurfaceDismissed} /> : null}
    </Stack>;
};

export default ContactsList;
